import { render, staticRenderFns } from "./AccountTransactions.vue?vue&type=template&id=ada82f72&scoped=true"
import script from "./AccountTransactions.vue?vue&type=script&lang=js"
export * from "./AccountTransactions.vue?vue&type=script&lang=js"
import style0 from "./AccountTransactions.vue?vue&type=style&index=0&id=ada82f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada82f72",
  null
  
)

export default component.exports